
import { Language } from "@/models/Base/LanguageOptions";
import { City } from "@/models/City";
import { Game } from "@/models/Game";
import { ManhuntMapPoi } from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { QuestMapPoi } from "@/models/MapPois/Quest/QuestMapPoi";
import { Quests } from "@/models/MapPois/Quest/Quests";
import DateHelper from "@/utils/DateHelper";
import QuestGameErrors from "@/utils/ErrorQuest/QuestGameErrors";
import ErrorsGame from "@/utils/ErrorsGame";
import WarningsGame from "@/utils/WarningsGame";
import QuestGameWarnings from "@/utils/ErrorQuest/QuestGameWarnings";
import { Component, Prop, Vue } from "vue-property-decorator";
import UnlockBox from "../Base/UnlockBox.vue";
import { Season } from "@/models/GameType";

@Component({
  components: {
    UnlockBox,
  },
})
class LanguageSelectCard extends Vue {
  @Prop({ default: null }) readonly title!: string;
  @Prop({ default: null }) readonly slug!: string;
  @Prop({ default: null }) readonly gameUid!: string;
  @Prop({ default: false }) readonly isBusy!: boolean;
  @Prop({ default: "" }) readonly gameType!: string;
  @Prop({ default: false }) readonly showButton!: boolean;
  @Prop({ default: false }) readonly isLocked!: boolean;
  @Prop({ default: false }) readonly isPopUp!: boolean;
  @Prop({ default: true }) readonly showClone!: boolean;
  @Prop({ default: true }) readonly buttonText!: string;

  lang = "EN";
  langOptions = Language;

  get getGameTypeButton(): string {
    if (this.gameType == "gameType") {
      return "New Item";
    } else if (this.gameType == "game") {
      return this.buttonText;
    } else if (this.gameType == "editPoi") {
      return "Clone Poi";
    } else if (this.gameType == "quest") {
      return "Add Quest";
    } else {
      return "new location";
    }
  }

  get getQuestData(): Quests[] {
    return this.$store.state.questStore.quest;
  }

  get getCssClass(): string {
    if (this.isPopUp) {
      return "";
    }
    return "mt-35 mb-60";
  }

  get editing(): boolean {
    if (this.gameType == "city") {
      return this.$store.state.cityStore.isEditing;
    } else if (this.gameType == "gameType") {
      return this.$store.state.gameStore.isEditing;
    } else if (
      this.gameType == "game" ||
      this.gameType == "editPoi" ||
      this.gameType == "quest"
    ) {
      return this.$store.state.gameStore.isGameEditing;
    } else {
      return true;
    }
  }

  get isFieldLocked(): boolean {
    if (this.isLocked && !this.editing) {
      return true;
    } else {
      return false;
    }
  }

  get isFieldEditable(): boolean {
    if (this.isLocked) {
      return false;
    } else {
      return true;
    }
  }

  get getShowButton(): boolean {
    return this.showButton;
  }

  get getMapPoi(): ManhuntMapPoi[] {
    return this.$store.state.mapPoiStore.mapPoi;
  }

  get getQuestMapPoi(): QuestMapPoi[] {
    return this.$store.state.mapPoiStore.questMapPoi;
  }

  get getGame(): Game {
    return this.$store.state.gameStore.games.find(
      (x: Game) => x.key == this.gameUid
    );
  }

  get getGameTypeString(): string {
    if (this.getGame !== undefined) {
      return this.getGame.gt_uid;
    }
    return "";
  }

  get getCityData(): City {
    return this.$store.state.cityStore.singleCity;
  }

  get getPreAppLaunch(): number {
    return this.$store.state.authenication.appPrelaunch._value;
  }
  get getSeason(): Season {
    return this.$store.state.gameStore.gameType.filter(
      (t: Season) => t.slug == this.getGame.seas_uid
    )[0];
  }

  get getGameIsLive(): boolean {
    try {
      if (this.gameType !== "city") {
        const status = DateHelper.getStatus(this.getGame, this.getPreAppLaunch);
        if (status === "LIVE") {
          return true;
        }
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  onLangSelected(value: string): void {
    this.$emit("language-change", value);
  }
  handleSubmitPressed(): void {
    this.$emit("handleSubmitPressed");
  }
  handleUnlock(): void {
    if (this.gameType === "game") {
      const status = DateHelper.getStatus(this.getGame, this.getPreAppLaunch);
      if (
        status === "LIVE" ||
        status === "PUBLISHED" ||
        status === "OPEN" ||
        status === "ENDED"
      ) {
        this.$bvModal.show("modal-publish-edit");
      }
      if (this.getGame.template == true) {
        this.$bvModal.show("modal-edit-game");
      } else {
        this.$emit("handleUnlock");
      }
    } else {
      this.$emit("handleUnlock");
    }
  }
  closePublishEdit(): void {
    this.$bvModal.hide("modal-publish-edit");
  }
  publishEdit(): void {
    this.$bvModal.hide("modal-publish-edit");
    this.$bvModal.hide("modal-edit-game");
    this.$emit("handleUnlock");
  }
  removeEdit(): void {
    this.$emit("handlelock");
  }
  openUnlockBox(): void {
    this.$bvModal.show("team-modal-unlock");
  }

  errorScan(): void {
    this.$store.dispatch("gameStore/getGameTypes", this.getGame.gt_uid);
    if (this.getGame.gt_uid === "manhunt") {
      new WarningsGame(
        this.getGame,
        this.slug,
        this.getMapPoi
      ).checkWarningsErrors();
      new ErrorsGame(
        this.slug,
        this.getMapPoi,
        this.getCityData
      ).checkGameErrors();
    } else {
      new QuestGameErrors(
        this.slug,
        this.getQuestMapPoi,
        this.getQuestData,
        this.getCityData,
        this.getSeason,
        this.$store.state.gameStore.games
      ).checkGameErrors();
      new QuestGameWarnings(
        this.slug,
        this.getQuestMapPoi,
        this.getQuestData,
        this.getCityData,
        this.getSeason,
        this.$store.state.gameStore.games
      ).checkGameWarnings();
    }
  }

  close(): void {
    this.$emit("handleClose");
  }

  closeModal(): void {
    this.$bvModal.hide("modal-edit-game");
  }
}
export default LanguageSelectCard;
